"use client"

interface DroppodStatusTextProps {
  hasClone: boolean
  scale: number
}

export const DroppodStatusText = ({ hasClone, scale }: DroppodStatusTextProps) => {
  const text = hasClone ? "Clone secured" : "No clone in pod"
  // Position: base 125,74 + offsets for 20px north (-20 from offsetY) and 8px east (+8 to offsetX)
  // Original was offsetX={-10} offsetY={30}
  // New: offsetX = -10 + 8 = -2, offsetY = 30 - 20 = 10
  const left = (125 + -2) * scale
  const top = (74 + 10) * scale
  const width = 110 * scale

  return (
    <div
      id="droppod-status-text"
      className="absolute flex items-center justify-center"
      style={{
        left,
        top,
        width,
      }}
    >
      <span
        className="text-white font-bold whitespace-nowrap"
        style={{
          fontSize: 9 * scale,
          textShadow: "0 0 8px rgba(0, 0, 0, 0.8), 0 0 16px rgba(0, 0, 0, 0.6), 0 0 24px rgba(0, 0, 0, 0.4)",
        }}
      >
        {text}
      </span>
    </div>
  )
}
